<template>
  <section class="announcement_bar" :style="bgColor">
    <a :href="shopifyData.barLink ? shopifyData.barLink : '#'">
      <div class="t-center big_container announcement_content">
        <!-- {{ slider.length }} -->

        <swiper
          v-if="slider.length > 1"
          :modules="module"
          :slides-per-view="1"
          :space-between="20"
          :loop="true"
          :speed="3000"
          class="mySwiper"
        >
          <swiper-slide v-for="(item, index) in slider" :key="index">
            <p class="announcement_bar_text" :style="color">
              {{ item }}
            </p>
          </swiper-slide>
        </swiper>
        <p v-else class="announcement_bar_text" :style="color">
          {{ shopifyData.announcementText }}
        </p>
        <span class="closeIcon">
          <svg
            id="Layer_1"
            class="closeSvg"
            style="enable-background: new 0 0 512 512"
            version="1.1"
            viewBox="0 0 512 512"
            xml:space="preserve"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <path
              :fill="color"
              d="M437.5,386.6L306.9,256l130.6-130.6c14.1-14.1,14.1-36.8,0-50.9c-14.1-14.1-36.8-14.1-50.9,0L256,205.1L125.4,74.5  c-14.1-14.1-36.8-14.1-50.9,0c-14.1,14.1-14.1,36.8,0,50.9L205.1,256L74.5,386.6c-14.1,14.1-14.1,36.8,0,50.9  c14.1,14.1,36.8,14.1,50.9,0L256,306.9l130.6,130.6c14.1,14.1,36.8,14.1,50.9,0C451.5,423.4,451.5,400.6,437.5,386.6z"
            />
          </svg>
        </span>
      </div>
    </a>
  </section>
</template>

<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';
// Import Swiper styles
import { Autoplay, EffectFade } from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-fade';
// import required modules

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      slider: [],
      module: [Autoplay, EffectFade],
    };
  },
  computed: {
    color() {
      return {
        color: this.shopifyData.textColor,
      };
    },
    bgColor() {
      return {
        backgroundColor: this.shopifyData.barBgColor,
      };
    },
  },
  mounted() {
    let string = this.shopifyData.announcementText;
    string = string.split('@');
    this.slider = string;

    window.addEventListener('load', () => {
      // console.log(this.shopifyData , "announcement")
    });
    window.addEventListener('load', this.setDynamicTop);
    window.addEventListener('resize', this.setDynamicTop);
    window.addEventListener('scroll', this.setDynamicTop);
    this.closeBar();
  },
  methods: {
    setDynamicTop() {
      const headerEle = document.querySelector('.tmbHeader');
      const headerEleHeight = headerEle.offsetHeight;
      const announcementBar = document.querySelector('.announcement_bar');
      const tmbMain = document.querySelector('.tmbMain');
      const BarHeight = announcementBar.offsetHeight;
      headerEle.setAttribute('style', `top: ${BarHeight}px`);
      tmbMain.setAttribute('style', `padding-top: ${BarHeight}px`);
      const navDropDowns = document.querySelectorAll('.navlink__hover');
      for (const i of navDropDowns) {
        i.setAttribute('style', `top:${headerEleHeight + BarHeight}px;`);
      }
    },

    closeBar() {
      const CloseIcon = document.querySelector('.closeIcon');
      const announcementBar = document.querySelector('.announcement_bar');
      CloseIcon.addEventListener('click', () => {
        announcementBar.classList.add('barClose');
        this.setDynamicTop();
      });
    },
  },
};
</script>

<style scoped>
.announcement_bar {
  background-color: #000;
  position: fixed;
  top: 0;
  width: 100%;
  text-align: center;
  z-index: 6;
}
.announcement_content {
  position: relative;
}
.announcement_bar_text {
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  color: #fff;
  padding: 8px 0;
  width: 88%;
  margin: 0 auto;
}
.closeIcon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 20px;
  width: 14px;
  height: 14px;
  cursor: pointer;
  z-index: 9;
  display: none;
}
.closeSvg {
  fill: #fff;
}
.barClose {
  display: none;
}
@media screen and (max-width: 767px) {
  .announcement_bar_text {
    font-size: 14px;
    line-height: 20px;
    padding: 13px 0;
  }
}
</style>
